import { useQuery } from '@tanstack/react-query';
import { http } from 'services/http';
import { DISTRIBUTION_AREAS_GET } from 'api/query-keys.ts';
import type { TStatisticDistributionAreaRes } from 'api/swagger';

export const useGetDistributionAreas = () => {
  return useQuery<TStatisticDistributionAreaRes[]>({
    queryKey: [DISTRIBUTION_AREAS_GET],
    queryFn: async () => {
      const { data } = await http.get<TStatisticDistributionAreaRes[]>('/v1/statistics/distribution-areas');
      return data;
    },
    retry: false,
    refetchOnWindowFocus: false,
  });
};
